import script from "./TaskView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskView.vue?vue&type=script&setup=true&lang=js"

import "./TaskView.vue?vue&type=style&index=0&id=2400c026&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2400c026"]])

export default __exports__